import { motion } from "framer-motion";
import ListItem from "@/components/ListItem";
import smuIcon from "@/assets/icons/smu.webp";
import umIcon from "@/assets/icons/um.webp";

const currentItems = [
  { icon: smuIcon, title: "Exchange Semester at SMU", subtitle: "Singapore" },
  { icon: umIcon, title: "Maastricht University", subtitle: "B.Sc. International Business" },
];

const CurrentStatus = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 0.15, duration: 0.5 }}
  >
    {currentItems.map((item, i) => (
      <ListItem key={item.title} {...item} delay={0.05 * i} />
    ))}
  </motion.div>
);

export default CurrentStatus;
